import { Box, Grid, GridSize, Typography } from "@mui/material";
import React, { ReactElement } from "react";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";

type Props = {
  title: string;
  contentSize: GridSize;
  children: ReactElement;
  required?: boolean;
  infoText?: string | null;
};

const FormGrid = ({
  title,
  contentSize,
  required,
  children,
  infoText,
}: Props) => {
  const Required = () => <span>*</span>;

  return (
    <Grid item container alignItems="start">
      <Grid item xs={3}>
        <Box
          height={40}
          display="flex"
          alignItems="center"
          justifyContent="end"
        >
          <Typography color="textSecondary" align="right" fontSize="16px">
            {title}
            {required && <Required />}
          </Typography>
          {infoText && (
            <InfoTooltip title={infoText} style={{ marginLeft: "8px" }} />
          )}
        </Box>
      </Grid>
      <Grid item xs={contentSize} marginLeft="16px">
        {children}
      </Grid>
    </Grid>
  );
};

export default FormGrid;
